import type { CSSProperties, ReactNode } from 'react';
import { ProseQuoteBody } from './ProseQuoteBody';
import { ProseCanvasHeading, ProseCanvasText } from './ProseCanvasElements';
import type { ProseRenderModel } from './useProseRenderMode';

/**
 * The surface-dependent halves of a prose block (LLAMS-610 DB-05). On the `static` surface each
 * returns the export markup it is handed, unchanged; the quote canvas swaps the body for its
 * in-place editor; the block editor wraps heading and body as selectable page elements.
 */
export function ProseTitleSlot({
  model,
  labelStyle,
  children
}: {
  model: ProseRenderModel;
  labelStyle: CSSProperties;
  children: ReactNode;
}): ReactNode {
  if (model.mode !== 'canvas') return children;
  if (!model.isFirstSlice) return null;
  return (
    <ProseCanvasHeading title={model.title} labelStyle={labelStyle}>
      {children}
    </ProseCanvasHeading>
  );
}

export function ProseBodySlot({ model, kind, children }: { model: ProseRenderModel; kind: string; children: ReactNode }): ReactNode {
  if (model.mode === 'quote' && model.quote) {
    return (
      <ProseQuoteBody kind={kind} bodyHtml={model.bodyHtml} onEditProse={model.quote.onEditProse} proseEditor={model.quote.proseEditor}>
        {children}
      </ProseQuoteBody>
    );
  }
  if (model.mode === 'canvas') {
    return (
      <ProseCanvasText kind={kind} bodyHtml={model.bodyHtml}>
        {children}
      </ProseCanvasText>
    );
  }
  return children;
}
